import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAllMarksBySubTaskGuid = createAsyncThunk(
  "Marks/GetAllMarksBySubTaskGuid",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Marks/GetAllMarksBySubTaskGuid", {
        subTaskFlowGUID: subTaskFlowGUID,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


  
export const UpdateAllMarks = createAsyncThunk(
  "Marks/UpdateAllMarks",
  async (marksEvaluationUpdateListtModel, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Marks/UpdateAllMarks", {
        marksEvaluationUpdateListtModel: marksEvaluationUpdateListtModel,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const GetAVGForSubTasksByTaskGuid = createAsyncThunk(
    "Marks/GetAVGForSubTasksByTaskGuid",
    async (taskFlowGUID, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post("api/Marks/GetAVGForSubTasksByTaskGuid", {
            taskFlowGUID: taskFlowGUID,
        });
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaaaaaaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const MarksManager = createSlice({
  name: "MarksManager",
  initialState: {
    MarksManager: [],
    loadingMarksManager: false,
    errorMarksManager: null,
    //------------------update-------------------
    MarksManagerUpdate: [],
    loadingMarksManagerUpdate: false,
    errorMarksManagerUpdate: null,
     //------------------AVG-------------------
     MarksAvg: 0,
     loadingMarksAvg: false,
     errorMarksAvg: null,
  },
  reducers: {
    SetMarksManager: (state, action) => {
      state.MarksManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllMarksBySubTaskGuid.pending, (state, action) => {
        state.loadingMarksManager = true;
        state.MarksManager = action.payload;
        state.errorMarksManager = null;
      })
      .addCase(GetAllMarksBySubTaskGuid.fulfilled, (state, action) => {
        state.loadingMarksManager = false;
        state.MarksManager = action.payload;
      })
      .addCase(GetAllMarksBySubTaskGuid.rejected, (state, action) => {
        state.loadingMarksManager = false;
        state.errorMarksManager = action.payload;
      })
      //---------------------update------------------------
      .addCase(UpdateAllMarks.pending, (state, action) => {
        state.loadingMarksManagerUpdate = true;
        state.MarksManagerUpdate = action.payload;
        state.errorMarksManagerUpdate = null;
      })
      .addCase(UpdateAllMarks.fulfilled, (state, action) => {
        state.loadingMarksManagerUpdate = false;
        state.MarksManagerUpdate = action.payload;
      })
      .addCase(UpdateAllMarks.rejected, (state, action) => {
        state.loadingMarksManagerUpdate = false;
        state.errorMarksManagerUpdate = action.payload;
      })
      
      //---------------------AVG------------------------
      .addCase(GetAVGForSubTasksByTaskGuid.pending, (state, action) => {
        state.loadingMarksAvg = true;
        state.MarksAvg = action.payload;
        state.errorMarksAvg = null;
      })
      .addCase(GetAVGForSubTasksByTaskGuid.fulfilled, (state, action) => {
        state.loadingMarksAvg = false;
        state.MarksAvg = action.payload;
      })
      .addCase(GetAVGForSubTasksByTaskGuid.rejected, (state, action) => {
        state.loadingMarksAvg = false;
        state.errorMarksAvg = action.payload;
      });
  },
});

export const { SetMarksManager } = MarksManager.actions;

export default MarksManager.reducer;
